import ChkIcon from '../../../../../resources/common/chk.svg';
import ChkOnIcon from '../../../../../resources/common/chk_on.svg';

const style = `\
  /*=====브라우저 권장 및 gsk 모달 =====*/
  #openModal{cursor:pointer;}
  .modal_container{
    position:fixed;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    max-width:700px;
    width:90%;
    background:#fff;
    padding:20px;
    border-radius: 6px;
    box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.2);
    z-index:999;
  }
  .modal_container .modal_close{
    display:block;
    margin-left: auto;
    height:40px;
    margin-bottom:10px;
  }
  .modal_container .modal_mid > h4{
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom:10px;
    word-wrap:break-word;
    word-break: keep-all;
  }
  .modal_container .modal_mid > span{
    display:block;
    font-size: 13px;
    line-height: 1.69;
    text-align: left;
    color: #666;
    margin-bottom:30px;
  }
  .modal_container .modal_mid ul{display: flex; justify-content: center; margin-bottom:20px}
  .modal_container .modal_mid ul li {margin-right:25px;}
  .modal_container .modal_mid ul li a{ display: flex; flex-direction: column; align-items:center; }
  .modal_container .modal_mid ul li:last-child{ margin-right:0px;}
  .modal_container .modal_mid ul li span{color:#666; margin-top: 5px;}
  .modal_container .btnBox{text-align:center;}
  .modal_container .modalBtn{width: 100px; height:40px; border-radius:4px; color:#fff; font-size: 13px;}
  .modal_container .cancelBtn{background-color: #a5adb9; margin-right:10px}
  .modal_container .confirmBtn{background-color: #6a6af8;}

  /*==============사전등록 모달창=================*/
    #registModal {
      position: fixed;
      max-width: 830px;
      width: 90%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 6px;
      background: #fff;
      padding-right: 0 !important;
    }
    .modal_header {
      background: #f8f8fe;
      padding: 20px;
      box-sizing: border-box;
    }
    .modal_header > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .modal_header h2 {
      font-size: 26px;
      font-weight: 900;
      line-height: 1.5;
      color: #111111;
    }
    .modal_header p {
      font-size: 13px;
      line-height: 1.63;
      color: #666666;
      margin-top: 5px;
    }
    .modal_content {
      padding: 25px 30px;
      box-sizing: border-box;
      height: calc(100vh - 335px);
      background: #fff;
      overflow-y: auto;
      min-height: 200px;
    }
    
    .modal_content p {
      line-height: 1.3;
    }
    .modal_content .modify_wrapper {
      margin-bottom: 30px;
    }
    .modal_content .modify_wrapper:last-child {
      margin-bottom: 0;
    }
    .addition_content .modify_wrapper ul li {
      float: unset;
      margin-bottom: 20px;
      width: 100%;
    }
    .modal_content h3 {
      font-size: 22px;
      font-weight: bold;
      line-height: 1.5;
      color: #333333;
      margin-bottom: 18px;
    }
    .modal_content .modify_wrapper .mypage_input {
      color: #333;
      border-bottom: 1px solid #ccc;
    }
    .modal_bg {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 9999;
    }
    .modal_bg.on {
      display: block;
    }
    .modal_content1 li {
      display: flex;
      position: relative;
      border-radius: 4px;
      border: 2px solid #f9f9f9;
      padding: 20px;
      box-sizing: border-box;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .modal_content1 li.active {
      box-shadow: 6px 6px 20px 0 rgba(106, 106, 248, 0.2);
      border: solid 2px #6a6af8;
    }
    @media (hover: hover) {
      .modal_content1 li:hover {
        box-shadow: 6px 6px 20px 0 rgba(106, 106, 248, 0.2);
        border: solid 2px #6a6af8;
      }
    }
    
    .modal_content1 li.active img {
      display: block;
    }
    .modal_content1 li h4 {
      font-size: 15px;
      border-right: 1px solid #eeeeee;
      font-weight: bold;
      line-height: 1.3;
      color: #333333;
      box-sizing: border-box;
      margin-right: 20px;
      padding-right: 20px;
    }
    .modal_content1 li div h5 {
      margin-bottom: 8px;
    }
    .modal_content1 li div span {
      font-size: 13px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
    }
    .modal_content1 li img {
      display: none;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
    .modal_footer {
      border-radius: 0 0 6px 6px;
      background: #f8f8fe;
      min-height: 88px;
    }
    
    .modal_footer div {
      padding: 20px 30px;
    }
    .modal_footer div button {
      border-radius: 4px;
      color: #fff;
      width: 160px;
      height: 48px;
      box-sizing: border-box;
    }
    .modal_footer div button.modal_prev_btn {
      font-size: 16px;
      background: #a5adb9;
    }
    .modal_footer div button.modal_next_btn {
      font-size: 16px;
      background: #6a6af8;
    }
    .modal_footer1 div {
      text-align: right;
    }
    #registModal .close_btn {
      position: relative;
      background: none;
      cursor: pointer;
      padding: 0;
    }
    .modal_footer2 {
      display: flex;
      justify-content: space-between;
    }
    
    .agree_container {
      margin-top: 30px;
    }
    
    .agree_container input[id="service_agree"],
    .agree_container input[id="privacy_agree"] {
      display: none;
    }
    .agree_container input[id="privacy_agree"] + label span,
    .agree_container input[id="service_agree"] + label span {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("${ChkIcon}");
      background-repeat: no-repeat;
      cursor: pointer;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    
    .agree_container input[id="service_agree"]:checked + label span,
    .agree_container input[id="privacy_agree"]:checked + label span {
      background: url("${ChkOnIcon}");
    }
    .agree_container .privacy_agree_box_inner label,
    .agree_container .service_agree_box_inner label {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #4e4b7b;
    }
    .agree_container .privacy_agree_box_inner label b,
    .agree_container .service_agree_box_inner label b {
      display: inline-block;
    }
    .privacy_agree_box {
      margin-bottom: 30px;
    }
    .privacy_agree_box_inner,
    .service_agree_box_inner {
      margin-bottom: 10px;
    }
    .privacy_agree_inner_textbox,
    .service_agree_inner_textbox {
      background: #f7f7fa;
      padding: 10px;
      box-sizing: border-box;
      height: 94px;
      overflow-y: auto;
    }
    
    .privacy_agree_inner_textbox p,
    .service_agree_inner_textbox p {
      font-size: 13px;
      line-height: 20px;
    }
    
    .modal_content3 {
      position: relative;
      height: 550px;
    }
    .modal_content3 > div {
      position: absolute;
      bottom: 20px;
      left: 30px;
    }
    .modal_content3 p {
      font-size: 52px;
      font-weight: 900;
      line-height: 1.48;
      text-align: left;
      color: #111111;
      margin-bottom: 20px;
    }
    .modal_content3 span {
      display: block;
      font-size: 13px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
    }
    .modal_footer3 {
      text-align: right;
    }
    .brand_logo_popup {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 600px;
      background: #f7f7fa;
      padding: 140px 20px 30px;
    }
    .brand_logo_popup_inner {
      width: 360px;
      margin: 0 auto 80px;
    }
    .brand_logo_popup_inner h2 {
      font-size: 40px;
      font-weight: 900;
      line-height: 1.48;
      text-align: center;
      color: #111111;
      margin-bottom: 110px;
    }
    .brand_logo_popup_inner a {
      display: block;
      font-size: 20px;
      font-weight: bold;
      line-height: 1.2;
      text-align: left;
      color: #6a6af8;
      margin-bottom: 20px;
    }
    .brand_logo_popup_inner span {
      display: block;
      line-height: 1.63;
      text-align: left;
      color: #666666;
      margin-bottom: 50px;
    }
    .brand_logo_popup_inner button {
      border-radius: 4px;
      background-color: #6a6af8;
      color: #fff;
      font-size: 16px;
      padding: 17px 120px;
    }
    .brand_logo_popup_btm h4 {
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333333;
      margin-bottom: 10px;
    }
    .brand_logo_popup_btm p {
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.63;
      letter-spacing: normal;
      text-align: left;
      color: #888888;
    }
    /*======사전등록모달창 모바일=======*/
    @media (max-width: 767px) {
      #registModal {
        position: fixed;
        top: 0;
        left: 0;
        transform: unset;
        border-radius: 0;
        width: 100%;
        height: 100%;
        max-height: fit-content;
      }
      .modal_header {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        padding: 10px 20px;
        z-index: 999;
      }
      .modal_header h2 {
        font-size: 20px;
      }
    
      .modal_content {
        padding: 141px 30px 25px;
        overflow-y: auto;
        height: calc(100vh - 78px);
      }
      .modal_content1 li div {
        width: 85%;
        word-break: keep-all;
      }
      .modal_content3 {
        padding: 116px 0 0 0;
        height: calc(100vh - 78px);
      }
      .modal_content1 h3 {
        display: none;
      }
      .modal_content1 li {
        flex-direction: column;
      }
      .modal_content1 li h4 {
        border-right: 0;
        margin-bottom: 20px;
        font-weight: bold;
      }
      .modal_content1 li h4:after {
        content: none;
        width: 20px;
        height: 1px;
        background: #eee;
        display: block;
        margin: 10px 0;
      }
      .modal_content1 li div span {
        font-size: 12px;
      }
      .modal_content .modify_wrapper {
        padding: 0;
      }
      .modify_wrapper ul li {
        float: unset;
        width: 100%;
      }
      .modal_footer {
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        min-height: 78px;
      }
      .modal_footer div {
        padding: 10px 20px;
        width: 100%;
        height: 100%;
      }
      .modal_footer1 div button {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
      }
      .modal_footer2 div {
        width: auto;
        padding: 10px 0;
      }
      .modal_footer2 div:first-child {
        padding-left: 20px;
        padding-right: 5px;
      }
      .modal_footer2 div:nth-child(2) {
        padding-right: 20px;
        padding-left: 5px;
      }
      .modal_footer3 div button {
        width: 100%;
      }
    
      .agree_container {
        width: 100%;
        margin: 0;
        flex-direction: column;
        background: #fff;
        margin-top: 30px;
      }
    
      .agree_container > li {
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
      }
    
      .agree_container > li:last-child {
        margin-bottom: 0;
      }
      .agree_container > div:nth-child(2) {
        margin-bottom: 0;
      }
      .modal {
        padding-right: 0 !important;
      }
      .modal_content3 p {
        font-size: 40px;
        font-weight: 900;
        line-height: 1.48;
        text-align: left;
        color: #111111;
        margin-bottom: 20px;
      }
      .modal_content3 span.modal_content3_span {
        display: inline-block;
        margin-bottom: 30px;
      }
    }
    /*==============동반참석 모달창=================*/
      #accompany_modal{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 90%;
        max-width: 830px;
        border-radius: 6px;
        overflow: hidden;
      }
      #accompany_modal .modal_header{border-radius: 6px 6px 0 0;}
      #accompany_modal .modal_header > div{
        align-items:flex-start;
      }
      #accompany_modal .modal_content{
        padding:20px;
        height:auto;
        margin-top:-1px;
        min-height:unset;
      }
      #accompany_modal .modal_content h4{
        font-size: 16px;
        font-weight: bold;
        color: #111;
        margin-bottom:10px;
      }
      #accompany_modal .modal_content h5{
        color:#6a6af8; font-size: 13px; font-weight: bold;
      }
      #accompany_modal .modal_content p{
        line-height:1.7;
        color: #666;
      }
      
      #accompany_modal .modal_content2{padding:0;}
      
      #accompany_modal .modal_content2 .modal_content_inner{
        background:#f7f7fa;
        padding:20px;
        overflow-y: auto;
        max-height: 265px;
      }
      #accompany_modal .modal_content2 .modal_content_inner li{display:flex; align-items:center; margin-bottom:10px;}
      #accompany_modal .modal_content2 .modal_content_inner li:last-child{
        margin-bottom:0;
      }
      #accompany_modal .modal_content2 .modal_content_inner li .accompany_list_imgbox{display:flex;}
      #accompany_modal .modal_content2 .modal_content_inner li img{display:inline-block; cursor:pointer;}
      #accompany_modal .modal_content2 .modal_content_inner li img:first-child{
        margin-right:10px;
      }
      #accompany_modal .modal_content2 .accompany_list{
        width:calc(100% - 100px);
        background:#fff;
        padding:10px 20px;
        border-radius:6px;
        margin-right:10px;
      }
      #accompany_modal .modal_content2 .accompany_list.active{
        border:1px solid #ef3232;
      }
      #accompany_modal .modal_content2 .accompany_list > div{
        display:flex;
        align-items:center;
      }
      #accompany_modal .modal_content2 .accompany_list span{
        display:block;
        width:6%;
        text-align:center;
        font-weight: bold;
        font-size: 16px;
        color: #333;
        margin-right: 10px;
      }
      #accompany_modal .modal_content2 .accompany_list span.m_index_num{display:none;}
      #accompany_modal .modal_content2 .accompany_list span.p_index_num{display:block;}
      #accompany_modal .modal_content2 .accompany_list input{
        border:none;
        border-bottom:1px solid #cccccc;
        width:47%;
        height:40px;
      }
      #accompany_modal .modal_content2 .accompany_list input:nth-child(2){
        margin-right:10px;
      }
      #accompany_modal .modal_content2 .accompany_list input:hover{
        border-bottom-color:#7758fa;
      }
            #accompany_modal .modal_content2 .accompany_list .accompany_list_input input::placeholder{
        color: #d4d4d4;
        font-family: "notokr", "맑은 고딕", NanumGothic, 나눔고딕, "notokr", "Helvetica Neue", Arial, sans-serif;
        letter-spacing: -0.5px;
        font-size: 15px;
        font-size: 0.9375rem;
        line-height: 40px !important;
        font-weight: 400;
      }
      #accompany_modal .modal_content2 .accompany_list .accompany_list_input input:focus-visible{outline:none;}
      #accompany_modal .modal_content2 .accompany_list .accompany_list_input input{
        color:#4c5161;
        font-family: "notokr", "맑은 고딕", NanumGothic, 나눔고딕, "notokr", "Helvetica Neue", Arial, sans-serif;
        letter-spacing: -0.5px;
        font-size: 15px;
        font-size: 0.9375rem;
        line-height: 1.4 !important;
        font-weight: 400;
      }

      #accompany_modal .modal_content2 > .btn_container{
        justify-content:space-between;
      }
      #accompany_modal .modal_content2 .accompany_list > div.errorMsg{
        display:block;
        padding: 10px 0 0px 50px;
        color:#ef3232;
      }
      #accompany_modal .modal_content2 .accompany_list div.m_errorMsg{display:none;}
      #accompany_modal .modal_content_3 .modal_content_inner{
        margin-top:20px;
        overflow-y: auto;
        max-height: 265px;
      }
      #accompany_modal .modal_content_3 .modal_content_inner li{
        display:flex;
        align-items: center;
        border-bottom: 1px solid #eeeeee;
        padding: 12px 0;
      }
      #accompany_modal .modal_content_3 .modal_content_inner li span,
      #accompany_modal .modal_content_3 .modal_content_inner li strong{display:inline-block; margin-right:10px; color:#333; }
      #accompany_modal .modal_content_3 .modal_content_inner li span{font-weight:bold;}
      #accompany_modal .modal_content_3 .modal_content_inner li strong{ margin-right:30px; width: 150px; white-space: nowrap; font-weight: normal;overflow: hidden;}
      #accompany_modal .modal_content_3 .modal_content_inner li p{font-size: 13px;
        line-height: 1.69;
        text-align: left;
        color: #666;
      }
      #accompany_modal .modal_content_3 .modal_content_inner li:last-child{
        margin-bottom:20px;
      }
      #accompany_modal .modal-footer1{padding:10px 0 20px; margin-top:-1px; background:#fff;}
      #accompany_modal .modal-footer1 > .btn_container {display:flex;justify-content:center; margin:0; font-size:16px;}
      
      #accompany_modal .modal-footer{padding:0;}
      #accompany_modal .accompany_btn{
        display:inline-block;
        width: 200px;
        height:40px;
        color: #fff;
        border-radius: 4px;
        font-size: 15px;
        font-weight: 600;
        background-color: #906af8;
        margin:0;
      }
      #accompany_modal .modal-footer{justify-content:space-between; background:#fff; border-top:none;padding:20px;}
      #accompany_modal .modal-footer .accompany_btn{background-color:#a5adb9;}
      #accompany_modal .modal-footer2 .accompany_btn:first-child{width:80px;}
      #accompany_modal .modal-footer2 .accompany_btn:last-child{width:100px;}
      #accompany_modal .modal-footer3{padding:0;}
      #accompany_modal .modal-footer3 .accompany_btn:first-child{width:80px;}
      #accompany_modal .modal-footer3 .accompany_btn:last-child{width:100px;}

      /*동반참석 모바일*/
      @media (max-width:767px){
        #accompany_modal{
          top:20px;
          transform:translateX(-50%);
          width: calc(100% - 40px);
          height: calc(100% - 40px);
          border-radius: 6px;
          max-height: 620px;
        }
        #accompany_modal .modal_content2 .accompany_list > div.errorMsg{display:none;}
        #accompany_modal .modal_content2 .accompany_list div.m_errorMsg{display:block; color:#ef3232; padding-top:10px;}
        #accompany_modal .modal_header > div{align-items:center;}
        #accompany_modal .modal_content{
          margin-top:60px;
          padding: 20px 20px 20px;
          overflow-y: auto;
          height: calc(100% - 128px);
        }
        #accompany_modal .modal_content2{
          padding:0;
        }
        
        #accompany_modal .modal_content2 .modal_content_inner{
          height: calc(100% - 181px);
          max-height:unset;
        }
        #accompany_modal .modal_content2 .accompany_list{width:100%; display:flex;}
        #accompany_modal .modal_content2 .accompany_list > div{
          flex-direction: column;
          align-items: flex-start;
          width:100%;
        }
        #accompany_modal .modal_content2 .accompany_list span{line-height: 40px;}
        #accompany_modal .modal_content2 .accompany_list span.p_index_num{display:none;}
        #accompany_modal .modal_content2 .accompany_list span.m_index_num{display:block;}
        #accompany_modal .modal_content2 .accompany_list input{
          margin-top:5px;
          margin-bottom:5px;
          width:100%;
        }
        #accompany_modal .modal_content2 .accompany_list input:nth-child(2){
          margin-right:0;
          margin-bottom:10px;
          margin-top:0;
        }
        #accompany_modal .modal_content2 .modal_content_inner li .accompany_list_imgbox{flex-direction:column-reverse;}
        #accompany_modal .modal_content2 .modal_content_inner li img:first-child{
          margin-right:0;
        }
        #accompany_modal .modal_content2 .modal_content_inner li img:nth-child(2){
          margin-bottom:10px;
        }
        #accompany_modal .modal_content_3 .modal_content_inner{max-height:unset;}
        #accompany_modal .modal-footer,#accompany_modal .modal-footer1{padding:10px 20px;}
        #accompany_modal .modal-footer1 .accompany_btn{font-size:13px;}
        #accompany_modal .modal-footer1 > .btn_container span{display:block; font-size:11px;}
        #accompany_modal .modal-footer2 .accompany_btn:first-child,
        #accompany_modal .modal-footer2 .accompany_btn:last-child,
        #accompany_modal .modal-footer3 .accompany_btn:first-child,#accompany_modal .modal-footer3 .accompany_btn:last-child{width:49%;}
        #accompany_modal .accompany_btn{
          width: 49%;
          height: 48px;
          font-size:16px;
        }
        #accompany_modal .modal-footer{
          position:fixed;
          bottom: 0;
          left:0;
          width:100%;
          padding:10px 20px;
          background:#f7f7fa;
        }
      }
    /*=============로그인창 푸터 개인정보처리방침, 사이트이용약관==============*/
    .ft_modal_container {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 1180px;
      background: #fff;
      z-index: 99999;
      border-radius: 6px;
      overflow: hidden;
    }
    
    .ft_modal_header {
      background: #f8f8fe;
      padding: 25px 30px;
      box-sizing: border-box;
    }
    .ft_modal_header > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .ft_modal_header h2 {
      font-size: 26px;
      font-weight: 900;
      line-height: 1.5;
      color: #111111;
    }
    .ft_modal_header p {
      font-size: 16px;
      line-height: 1.63;
      color: #666666;
      margin-top: 5px;
    }
    .ft_modal_content {
      line-height: 1.54;
      padding: 25px 30px;
      box-sizing: border-box;
      height: calc(100vh - 300px);
      background: #fff;
      color:#666;
      overflow-y: auto;
    }
    .ft_modal_content table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .ft_modal_content table tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    /*======로그인창 푸터 개인정보처리방침 모바일, 사이트이용약관 모바일=======*/
    @media (max-width: 767px) {
      .ft_modal_container {
        width: 100%;
        top: 0;
        left: 0;
        transform: unset;
        max-height: none;
        height: 100%;
        border-radius: 0;
      }
    
      .ft_modal_header {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        padding: 8px 20px;
        z-index: 999;
      }
      .ft_modal_header h2 {
        font-size: 18px;
      }
    
      .ft_modal_content {
        margin-top: 60px;
        padding: 20px;
        overflow-y: auto;
        height: calc(100% - 60px);
      }
    }
    
    /*=============스피커 프로필 모달창=================*/
    .speaker_profile_container .close_btn {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      background: none;
      cursor: pointer;
      padding: 0;
    }
    .speaker_profile_container .close_btn.m_width_close_btn,
    .m_width_inform_text{display:none;}
    .profile_img {
      position: relative;
      width: 240px;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.3);
    }
    
    .profile_img img.profile_image {
      width: 162px;
      height: 162px;
      display: block;
      margin: 70px auto 20px;
      z-index: 9999;
      border-radius: 50%;
      background-color:#D0D0DE;
    }
    .profile_img img.background_img {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      -webkit-filter: blur(60px);
      -moz-filter: blur(60px);
      -o-filter: blur(60px);
      -webkit-filter: blur(60px);
      filter: blur(60px);
      backdrop-filter: blur(60px);
      z-index: -1;
      min-width:300px;
      min-height:900px;
    }
    .profile_img .profile_content pre {
      font-family: "Noto Sans KR", sans-serif;
    }
    .profile_img .profile_content_top_text {
      margin:0 35px;
    }
    .profile_img .profile_content_top_text h2 {
      font-size: 22px;
      color: #fff;
      margin-bottom: 10px;
    }
    .profile_img .profile_content_top_text_j h2 {
      font-size: 22px;
      color: #fff;
      margin-bottom: 10px;
      white-space: nowrap; /* 줄바꿈 방지 */
    }
    .profile_img .profile_content_top_text p {
      font-size: 13px;
      line-height: 1.63;
      color: #fff;
    }
    .profile_img .profile_content_top_text_j p {
      font-size: 13px;
      line-height: 1.63;
      color: #fff;
      white-space: nowrap; /* 줄바꿈 방지 */
    }
    .profile_content {
      width: calc(100% - 240px);
      background: #fff;
    }
    .profile_content_top {
      display: flex;
      justify-content: space-between;
      padding: 20px;
    }
    .profile_content_top h2 {
      font-size: 26px;
      font-weight: 900;
      color: #111111;
      line-height: initial;
    }
    
    .profile_content_mid {
      padding: 20px 35px;
      max-height: calc(100% - 77px);
      overflow: auto;
      width: 100%;
    }
    .profile_content_mid table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .profile_content_mid table tbody tr td{
      border: 1px solid rgb(218, 218, 218);
      min-width: 2em;
      padding: 0.4em;
      user-select: text;
      vertical-align: middle;
    }
    .profile_content_mid h3 {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
    }
    .profile_content_mid p {
      line-height: 1.63;
      color: #666666;
    }
    .profile_content_mid pre {
      font-family: "Noto Sans", sans-serif;
      width: 100%;
      white-space: break-spaces;
      font-size: 13px;
      line-height: 1.63;
      letter-spacing: normal;
      color: #666666;
    }
    .m_profile_content_top {
      display: none;
    }
    /*=====프로필 모달창 모바일 가로모드====*/
    @media (orientation: landscape) and (max-width: 950px) and (max-device-height: 500px){
      .profile_content_top{display:none;}
      .m_profile_flex{
        overflow-y: auto;
        height: 100%;
      }
      .m_width_inform_text{
        display:block;
        margin: 0 auto;
        margin: 20px 0 0 20px;
        font-size: 20px;
        color: #fff;
        text-align: left;
      }
      .m_width_close_btn{display:block;}
      .profile_content_mid{padding: 20px 50px 20px 20px; height: calc(100vh - 50px);}
      .speaker_profile_container .close_btn.m_width_close_btn{display:block; right:10px;}
      .profile_img img.profile_image{width:120px; height:120px; margin:10px auto 15px;}
      .profile_img .profile_content_top_text{text-align:center;}
    }
    /*=================스피커 프로필 모바일 모달창==================*/
    @media (max-width: 767px) {
      .profile_content_top {
        display: none;
      }
      .m_profile_content_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding:20px;
      }
      .m_profile_content_top h2 {
        font-size: 20px;
        color: #fff;
      }
      .m_profile_content_top .close_btn .line {
        background: #fff;
      }
      .speaker_profile_container {
        position: unset;
        top: auto;
        left: auto;
        transform: unset;
        width: 100%;
        flex-direction: column;
        min-height: auto;
        max-height: 100%;
        border-radius: 0;
      }
      .speaker_profile_container .close_btn {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .m_profile_flex{display:flex; align-items:flex-start; height: calc(100% - 61px); padding: 0 20px; overflow: auto; gap:20px;}
      .profile_img {
        width: 100%;
        box-sizing: border-box;
        height: 100%;
        max-height: 240px;
        padding-bottom:20px;
      }
      .profile_img img.profile_image {
        width: 100px;
        height: 100px;
        margin: 0;
      }
      .profile_img img.background_img {
        top: 20%;
      }
      .profile_img .profile_content_top_text {
        text-align: left;
        margin:0;
      }
      .profile_content {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        height: calc(100vh - 240px);
        overflow-y: auto;
      }
      .profile_content_mid {
        margin-bottom: 0;
        padding: 0;
        max-height: 100%;
        overflow-y: unset;
      }
      .profile_content_mid pre {
        padding: 20px;
      }
      .modal-backdrop {
        display: none !important;
      }
    }
    
    /*=========alert=========*/
    .alert_container {
      width: 500px;
      height: 180px;
      padding: 20px;
      box-sizing: border-box;
    }
    .alert_container p {
      color: #666;
      line-height: 26px;
      margin-bottom: 25px;
    }
    .alert_container div {
      text-align: center;
    }
    .alert_container div button {
      width: 130px;
      height: 40px;
      background: #6a6af8;
      color: #fff;
      border-radius: 4px;
    }
    .modal {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0,0,0,0.5);
    }
    .modal-dialog {
      min-width: 832px;
      min-height: 743px;
    }



    /*사전등록 페이지*/
    .preregister_con{
      width:100%;
      margin:20px auto 0;
      margin-bottom:40px;
      box-sizing: border-box;
    }
    .preregister_con .swiper-container{border-radius:6px;}
    .preregister_con .swiper-container .swiper-slide{width:100%;}
    .preregister_con .swiper-pagination-bullets{
      bottom: 20px;
      left: 20px;
      text-align: left;
    }
    .preregister_con .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: none;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .preregister_con .swiper-pagination-bullet-active {
      background: #373779;
    }

    .MuiTypography-root i.required {
      font-family: 'Noto Sans KR';
      font-style: inherit;
      color:unset;
      margin-left:2px;
    }
    /**
     * ==============================================
     * Dot Flashing
     * ==============================================
     */
    .snippet_box{
      margin: 15px auto;
    }
    .dot-flashing {
      position: relative;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #7878a5;
      color: #7878a5;
      animation: dotFlashing 1s infinite linear alternate;
      animation-delay: .5s;
    }

    .dot-flashing::before, .dot-flashing::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
    }

    .dot-flashing::before {
      left: -15px;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #7878a5;
      color: #7878a5;
      animation: dotFlashing 1s infinite alternate;
      animation-delay: 0s;
    }

    .dot-flashing::after {
      left: 15px;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #7878a5;
      color: #7878a5;
      animation: dotFlashing 1s infinite alternate;
      animation-delay: 1s;
    }

    @keyframes dotFlashing {
      0% {
        background-color: #7878a5;
      }
      50%,
      100% {
        background-color: #ebe6ff;
      }
    }
    @media (max-width: 767px) {
      .preregister_con .swiper-container{
        padding-bottom:40px
      }
      .preregister_con .swiper-pagination-bullets{
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
      }
    }
    /*사전등록 페이지 끝*/
    
    .sch_inform{
      margin-bottom:60px;
    }
    .sch_inform h2{
      font-size: 32px;
      font-weight: bold;
      text-align: left;
      color: #333;
      margin-bottom:10px;
    }
    .sch_inform p{
      font-size: 15px;
      line-height: 1.47;
      text-align: left;
      color: #666;
      margin-bottom:20px;
    }
    .sch_inform ul{display:flex; align-items:center;}
    .sch_inform ul li{position:relative; margin-right:20px;}
    .sch_inform ul li:after{
      content:"";
      display:block;
      position:absolute;
      top:50%;
      transform:translateY(-50%);
      right:0;
      background:#ccc;
    }
    .sch_inform ul li a{
      font-size: 15px;
      font-weight: bold;
      line-height: 2.4;
      text-align: left;
      color: #6a6af8;
    }

    .offline{
      display:inline-block;
      border-radius: 12px;
      background:#723ec6;
      color:#fff;
      margin-right:4px;
      padding:1px 10px;
    }

`

export default style